import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class TransferDocumentToOtherCompany {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(doc_id): Promise<any> {
    let args = { 
      inv_id: doc_id
    }
    return await this.dispatcher.dispatch('perform.transfer.to.right.company', args)
  }
}